import { render } from "./SystemMenuButton.vue?vue&type=template&id=86b76ae2"
import script from "./SystemMenuButton.vue?vue&type=script&lang=js"
export * from "./SystemMenuButton.vue?vue&type=script&lang=js"

import "./SystemMenuButton.vue?vue&type=style&index=0&id=86b76ae2&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__